import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import './assets/css/main.scss'
import Signin from './Signin';
import DashBoard from './components/ContentSection/DashBoard/DashBoard';
import CustomerManagement from './components/CustomerManagement/CustomerManagement';
import UserManagement from './components/UserManagement/UserManagement';
import Leaves from './components/Leaves/Leaves';
import LeaveDetails from './components/Leaves/LeaveDetails';
import ComplaintEscalation from './components/ComplaintEscalation/ComplaintEscalation';
import SLA from './components/SLA/SLA';
import WorkQueues from './components/WorkQueues/WorkQueues';
import AuditTrial from './components/SystemLogging/AuditTrial';
import Settings from './components/Settings/Settings';
import Roles from './components/Settings/Roles/Roles';
import Department from './components/Settings/Department/Department';
import Designation from './components/Settings/Designation/Designation';
import CustomerClassification from './components/Settings/CustomerClassification/CustomerClassification';
import RelationShipType from './components/Settings/RelationShipType/RelationShipType';
import IssueType from './components/Settings/IssueType/IssueType';
import CustomFields from './components/Settings/CustomFields/CustomFields';
import ModuleManagement from './components/Settings/ModuleManagement/ModuleManagement';
import FunctionalApproval from './components/Settings/FunctionalApproval/FunctionalApproval';
import FinancialApproval from './components/Settings/FinancialApproval/FinancialApproval';
import ComplaintsApproval from './components/Settings/ComplaintsApproval/ComplaintsApproval';
import EscalationApproval from './components/Settings/EscalationApproval/EscalationApproval';
import LeaveApproval from './components/Settings/LeaveApproval/LeaveApproval';
import SlaCategories from './components/Settings/SlaCategories/SlaCategories';
import SystemNumbering from './components/Settings/SystemNumbering/SystemNumbering';
import OrganizationChart from './components/Settings/OrganizationChart/OrganizationChart';
import WqRules from './components/Settings/WqRules/WqRules';
import LeaveHolidayPolicy from './components/Settings/LeaveHolidayPolicy/LeaveHolidayPolicy';
import UserProfileForm from './components/MainSection/Header/UserProfileForm';
import LicenceDashboard from './components/UserManagement/LicenceDashboard';
import AttendanceAndLeavesDashboard from './components/Leaves/AttendanceAndLeavesDashboard';
import ComplaintEscalationDashboard from './components/ComplaintEscalation/ComplaintEscalationDashboard';
import ServiceLevelAgreementDashboard from './components/SLA/ServiceLevelAgreementDashboard';
import ExceptionLog from './components/SystemLogging/ExceptionLog';
import IntegrationLog from './components/SystemLogging/IntegrationLog';
import DashboardLibrary from './components/DashboardLibrary/DashboardLibrary';
import DimpuSignin from './DimpuSignin';
import Modules from './components/Settings/Modules/Modules';
import SubModules from './components/Settings/SubModules.js/SubModules';
import VerifyCompany from './VerifyCompany';
import VerifyOtp from './VerifyOtp';
import ResetPassword from './ResetPassword';
import WorkQueueDetail from './components/WorkQueues/WorkQueueDetail';
import Forgetpassword from './Forgetpassword';
import DemandDashboard from './components/PowerBi/DemandDashboard';
import AccessDenied from './components/AccessDenied';
import ViewComplaints from './components/ComplaintEscalation/ViewComplaints';
import RestDataSources from './components/Settings/RestDataSources/RestDataSources';
import AddRestDataSourcePage from './components/Settings/RestDataSources/AddRestDataSourcePage';
import Callback from './Callback';
import UseSessionTimeout from './UseSessionTimeout';
import SessionExpiredModal from './components/SessionExpiredModal';
import ManageOrders from './components/ManageOrders/ManageOrders';
import DynamicDashboards from './components/Settings/DynamicDashboards/DynamicDashboards';
import InventoryFilter from './components/InventoryFilter';
import AddManageOrders from './components/ManageOrders/AddManageOrders';
import ModuleField from './components/Settings/ModuleField/ModuleField';

function App() {

  const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

  const Success = sessionStorage.getItem("Success");
  // Define a state variable to hold the window height
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setWindowHeight(window.innerHeight);
  };

  const [sessionExpired, setSessionExpired] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleSessionClose = () => {
    sessionStorage.clear(); // Clear session storage
    window.location.href = '/';
  };

  return (
    // <Router>
    <div className="App" style={{ height: windowHeight }}>
      {/* Session Expired Modal */}
      {sessionExpired && (
        <SessionExpiredModal
          show={sessionExpired}
          // onClose={handleSessionClose}
          message={errorMessage}
        />
      )}
      {/* <UseSessionTimeout> */}
      {Success !== '1' ? (<Routes >
        <Route path="/" element={<Signin />} />
        {/* <Route path="*" element={<Signin />} /> */}
        <Route path="/verifyOtp" element={<VerifyOtp />} />
        <Route path='/verifyaccount' element={<VerifyCompany />} />
        <Route path='/forgetpassword' element={<Forgetpassword />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path="/oktacallback" element={<Callback />} />
      </Routes>
      ) : (
        < UseSessionTimeout >
          <Routes>
            {signInDetails[0].SignInType === "SuperAdmin" && <Route path="/login-in" element={<Signin />} />}
            {/* <Route path="/" element={<DashBoard />} /> */}
            {(signInDetails[0].SignInType !== "ClientAdmin" && signInDetails[0].SignInType !== "User") &&
              <Route path="/" element={<DashBoard />} />
            }
            {(signInDetails[0].SignInType === "ClientAdmin" || signInDetails[0].SignInType === "User") &&
              <Route path="/" element={<DashboardLibrary />} />
            }
            {(signInDetails[0].SignInType === "SuperAdmin") &&
              <Route path="/dashboard" element={<DashBoard />} />
            }
            {(signInDetails[0].SignInType === "ClientAdmin") &&
              <Route path="/dashboard" element={<LicenceDashboard />} />
            }
            {(signInDetails[0].SignInType === "User") &&
              <Route path="/dashboard" element={<AttendanceAndLeavesDashboard />} />
            }


            <Route path="/customermanagement" element={<CustomerManagement />} />
            <Route path="/usermanagement" element={<UserManagement />} />
            <Route path="/licenceDashboard" element={<LicenceDashboard />} />
            <Route path="/leaves" element={<Leaves />} />
            <Route path="/leaveDetails/:leaveId" element={<LeaveDetails />} />
            <Route path="/complaint" element={<ComplaintEscalation />} />
            <Route path="/complaint-history/:id" element={<ViewComplaints />} />
            <Route path="/sla" element={<SLA />} />
            <Route path="/workqueues" element={<WorkQueues />} />
            <Route path="/workqueues/:id" element={<WorkQueueDetail />} />
            <Route path="/audit-trial" element={<AuditTrial />} />
            <Route path="/powerbi-dashboard/:dashboardId" element={<DemandDashboard />} />
            {/* <Route path="/settings" element={<Settings />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings" element={<Settings />} />
            ) : (
              <Route path="/settings" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/roles" element={<Roles />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/roles" element={<Roles />} />
            ) : (
              <Route path="/settings/roles" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/department" element={<Department />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/department" element={<Department />} />
            ) : (
              <Route path="/settings/department" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/designation" element={<Designation />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/designation" element={<Designation />} />
            ) : (
              <Route path="/settings/designation" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/customerClassification" element={<CustomerClassification />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/customerClassification" element={<CustomerClassification />} />
            ) : (
              <Route path="/settings/customerClassification" element={<AccessDenied />} />
            )}
            <Route path="/settings/relationshipType" element={<RelationShipType />} />
            {/* <Route path="/settings/issueType" element={<IssueType />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/issueType" element={<IssueType />} />
            ) : (
              <Route path="/settings/issueType" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/customFields" element={<CustomFields />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/customFields" element={<CustomFields />} />
            ) : (
              <Route path="/settings/customFields" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/moduleMangement" element={<ModuleManagement />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/moduleMangement" element={<ModuleManagement />} />
            ) : (
              <Route path="/settings/moduleMangement" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/functionalApproval" element={<FunctionalApproval />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/functionalApproval" element={<FunctionalApproval />} />
            ) : (
              <Route path="/settings/functionalApproval" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/financialApproval" element={<FinancialApproval />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/financialApproval" element={<FinancialApproval />} />
            ) : (
              <Route path="/settings/financialApproval" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/complaintsApproval" element={<ComplaintsApproval />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/complaintsApproval" element={<ComplaintsApproval />} />
            ) : (
              <Route path="/settings/complaintsApproval" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/escalationApproval" element={<EscalationApproval />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/escalationApproval" element={<EscalationApproval />} />
            ) : (
              <Route path="/settings/escalationApproval" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/leaveApproval" element={<LeaveApproval />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/leaveApproval" element={<LeaveApproval />} />
            ) : (
              <Route path="/settings/leaveApproval" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/slaCategories" element={<SlaCategories />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/slaCategories" element={<SlaCategories />} />
            ) : (
              <Route path="/settings/slaCategories" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/systemNumbering" element={<SystemNumbering />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/systemNumbering" element={<SystemNumbering />} />
            ) : (
              <Route path="/settings/systemNumbering" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/organizationChart" element={<OrganizationChart />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/organizationChart" element={<OrganizationChart />} />
            ) : (
              <Route path="/settings/organizationChart" element={<AccessDenied />} />
            )}
            {/* <Route path="/settings/wqRules" element={<WqRules />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/wqRules" element={<WqRules />} />
            ) : (
              <Route path="/settings/wqRules" element={<AccessDenied />} />
            )}
            <Route path="/settings/modules" element={<Modules />} />
            <Route path="/settings/module-field" element={<ModuleField />} />
            <Route path="/settings/sub-modules" element={<SubModules />} />
            {/* <Route path="/settings/holidays" element={<LeaveHolidayPolicy />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/holidays" element={<LeaveHolidayPolicy />} />
            ) : (
              <Route path="/settings/holidays" element={<AccessDenied />} />
            )}
            <Route path="/settings/rest-data-sources" element={<RestDataSources />} />
            <Route path="/rest-data-sources/add" element={<AddRestDataSourcePage />} />
            <Route path="/userProfile" element={<UserProfileForm setSessionExpired={setSessionExpired} setErrorMessage={setErrorMessage} />} />
            <Route path="/attendanceDashboard" element={<AttendanceAndLeavesDashboard />} />
            <Route path="/complaintDashboard" element={<ComplaintEscalationDashboard />} />
            <Route path="/slaDashboard" element={<ServiceLevelAgreementDashboard />} />
            <Route path="/exception-log" element={<ExceptionLog />} />
            <Route path="/integration-log" element={<IntegrationLog />} />
            <Route path="/dashboard-library" element={<DashboardLibrary />} />
            <Route path="/dimpu" element={<DimpuSignin />} />
            <Route path="/access-denied" element={<AccessDenied />} />
            <Route path="/motor-builder" element={<ManageOrders />} />
            <Route path="/motor-builder-add" element={<AddManageOrders />} />
            {/* <Route path="/settings/dynamic-dashboards" element={<DynamicDashboards />} /> */}
            {(signInDetails[0].SignInType === "SuperAdmin" || signInDetails[0].SignInType === "ClientAdmin") ? (
              <Route path="/settings/dynamic-dashboards" element={<DynamicDashboards />} />
            ) : (
              <Route path="/settings/dynamic-dashboards" element={<AccessDenied />} />
            )}
            <Route path="/settings/inventory" element={<InventoryFilter />} />
          </Routes>
        </UseSessionTimeout>
      )}
      {/* </UseSessionTimeout> */}
    </div >
    // </Router >
  );
}

export default App;
